<template>
  <inline-modal :requested="true" @modal-closed="$emit('cancel')">
    <template v-slot:before-content>
      <div></div>
    </template>
    <div class="site_alert">
      <loading-spinner style="color: #999" v-if="loading"></loading-spinner>
      <div v-else>
        <div class="content">
          <slot></slot>
        </div>
        <div class="actions">
          <button v-if="cancelText" type="button" class="secondary" @click="$emit('cancel')">{{ cancelText }}</button>
          <button type="button" class="primary" @click="$emit('confirm')">{{ confirmText }}</button>
        </div>
      </div>
    </div>
  </inline-modal>
</template>

<script>
import InlineModal from '../InlineModal'
import LoadingSpinner from '../../atoms/loading_spinner.js';

export default {
  components: {
    LoadingSpinner,
    InlineModal
  },
  props: ['cancelText', 'confirmText', 'loading'],
  mounted() {
    this.$once('hook:destroyed', () => {
      const $class = 'modal-open', $el = document.querySelector('body');
      $el.classList.remove($class);
    })
  },
}
</script>